import { snackbarSlice } from './snackbar-slice'

export const { displayMessage, closeMessage } = snackbarSlice.actions
